module.exports = __webpack_public_path__ + "media/images/whats-next-icon-27871088658b43ab6a1414a76f70637b.svg";